import MenubarItem from './MenubarItemLinks';
const bodyElement = document.querySelector('body');

class Menubar {
    constructor(domNode) {
        this.isMenubar = true;
        this.domNode = domNode;
    
        this.menubarItems = []; // See Menubar init method
        this.firstChars = []; // See Menubar init method
    
        this.firstItem = null; // See Menubar init method
        this.lastItem = null; // See Menubar init method
    
        this.hasFocus = false; // See MenubarItem handleFocus, handleBlur
        this.hasHover = false; // See Menubar handleMouseover, handleMouseout

        this.previousScrollY = 0;

        const msgPrefix = 'Menubar constructor argument menubarNode ';
    
        // Check whether menubarNode is a DOM element
        if (!domNode instanceof Element) {
            throw new TypeError(msgPrefix + 'is not a DOM Element.');
        }
        
        // Check whether menubarNode has descendant elements
        if (domNode.childElementCount === 0) {
            throw new Error(msgPrefix + 'has no element children.');
        }

        // Check whether menubarNode has A elements
        let e = domNode.firstElementChild;
        while (e) {
            let menubarItem = e.firstElementChild;
            if (e && menubarItem && menubarItem.tagName !== 'A') {
                throw new Error(msgPrefix + 'has child elements are not A elements.');
            }
            e = e.nextElementSibling;
        }
    }

    init() {
        let textContent, numItems;
  
        const menuLinkElems = this.domNode.querySelectorAll(':scope > li > .menu-link');
        for (const linkElem of menuLinkElems) {
            if (linkElem && linkElem.tagName === 'A') {
                const menubarItem = new MenubarItem(linkElem, this);
                menubarItem.init();
                this.menubarItems.push(menubarItem);
                textContent = linkElem.textContent.trim();
                this.firstChars.push(textContent.substring(0, 1).toLowerCase());
            }
        }
      
        // Use populated menuitems array to initialize firstItem and lastItem.
        numItems = this.menubarItems.length;
        if (numItems > 0) {
            this.firstItem = this.menubarItems[ 0 ];
            this.lastItem = this.menubarItems[ numItems - 1 ];
        }
        this.firstItem.domNode.tabIndex = 0;
    }

    setFocusToItem(newItem) {
        var flag = false;
      
        for (const mbi of this.menubarItems) {
            if (mbi.domNode.tabIndex == 0) {
                flag = mbi.domNode.getAttribute('aria-expanded') === 'true';
            }
    
            mbi.domNode.tabIndex = -1;
            if (mbi.popupMenu) {
                mbi.popupMenu.close();
            }
        }
      
        newItem.domNode.focus();
        newItem.domNode.tabIndex = 0;
      
        if (flag && newItem.popupMenu) {
            newItem.popupMenu.open();
        }
    }

    setFocusToFirstItem(flag) {
        this.setFocusToItem(this.firstItem);
    }
      
    setFocusToLastItem(flag) {
        this.setFocusToItem(this.lastItem);
    }
      
    setFocusToPreviousItem(currentItem) {
        var index, newItem;
      
        if (currentItem === this.firstItem) {
            newItem = this.lastItem;
        } else {
            index = this.menubarItems.indexOf(currentItem);
            newItem = this.menubarItems[ index - 1 ];
        }
      
        this.setFocusToItem(newItem);
    }
      
    setFocusToNextItem(currentItem) {
        var index, newItem;
      
        if (currentItem === this.lastItem) {
            newItem = this.firstItem;
        } else {
            index = this.menubarItems.indexOf(currentItem);
            newItem = this.menubarItems[ index + 1 ];
        }
      
        this.setFocusToItem(newItem);
      
    }
    
    setFocusByFirstCharacter(currentItem, char) {
        var start, index, char = char.toLowerCase();
        var flag = currentItem.domNode.getAttribute('aria-expanded') === 'true';
      
        // Get start index for search based on position of currentItem
        start = this.menubarItems.indexOf(currentItem) + 1;
        if (start === this.menubarItems.length) {
          start = 0;
        }
      
        // Check remaining slots in the menu
        index = this.getIndexFirstChars(start, char);
      
        // If not found in remaining slots, check from beginning
        if (index === -1) {
          index = this.getIndexFirstChars(0, char);
        }
      
        // If match was found...
        if (index > -1) {
          this.setFocusToItem(this.menubarItems[ index ]);
        }
    }
    
    getIndexFirstChars(startIndex, char) {
        for (var i = startIndex; i < this.firstChars.length; i++) {
          if (char === this.firstChars[ i ]) {
            return i;
          }
        }
        return -1;
    }
    
    setPreviousScrollY(previousScrollY) {
        this.previousScrollY = previousScrollY;
    }

    close() {
        bodyElement.classList.remove('menuopen');
        document.querySelector('.menu-toggle .menu-text').innerHTML = 'Menu';
        bodyElement.style.position = 'initial';
        window.scrollTo(0, this.previousScrollY);
    }

    closePopmenu() {
        for (const menubarElem of this.menubarItems) {
            if (menubarElem.domNode.getAttribute('aria-expanded') === 'true') {
                if (menubarElem.popupMenu) {
                    menubarElem.popupMenu.setFocusToController();
                    menubarElem.popupMenu.close(true);
                }
            }
        }
    }
}

export default Menubar;